import { useMenu, useSubMenu } from '../../../hooks/menu';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
export function ItemGroup(props) {
  var title = props.title,
      icon = props.icon,
      children = props.children;
  var menu = useMenu();
  var subMenu = useSubMenu();
  var collapse = menu.getCollapse();
  var level = subMenu == null ? 1 : (subMenu.getLevel() || 0) + 1;
  var paddingLeft = '16px';

  if (!collapse) {
    paddingLeft = "".concat(level * 24, "px");
  }

  var style = {
    paddingLeft: paddingLeft
  };
  var cls = usePrefixCls('item-group');
  var itemGroupHeaderCls = usePrefixCls('item-group-header');
  var itemLineTitleCls = usePrefixCls('menu-line-title');
  var menuLineIconCls = usePrefixCls('menu-line-icon');
  var itemGroupContentCls = usePrefixCls('item-group-content');
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: itemGroupHeaderCls,
    style: style
  }, icon && React.createElement("span", {
    className: menuLineIconCls
  }, icon), React.createElement("span", {
    className: itemLineTitleCls
  }, title)), React.createElement("div", {
    className: itemGroupContentCls
  }, children));
}